<template>
  <section class="premium-plus-hero">
    <div class="premium-plus-hero__content">
      <h1 class="premium-plus-hero__title">Don't Wait Until Black Friday</h1>
      <div class="premium-plus-hero__description">
        <p>
          This flash sale offers Black Friday level savings on a PremiumPlus subscription - but you
          don't have to wait months to start your learning journey.
        </p>
        <p>
          For 48 hours only, save $200 on the complete package that will transform your tech career.
        </p>
        <div class="premium-plus-hero__description-coupon-text">
          $200 off PremiumPlus&nbsp; | &nbsp;Code:
          <span class="premium-plus-hero__description-coupon">200PREMPLUS25</span>
        </div>
      </div>
    </div>

    <div class="premium-plus-hero__logo-wrapper-mobile">
      <FlashSaleLogoMobileSVG
        class="premium-plus-hero__logo-wrapper-logo-mobile"
      ></FlashSaleLogoMobileSVG>
    </div>

    <div class="premium-plus-hero__logo-wrapper">
      <FlashSaleLogoSVG class="premium-plus-hero__logo-wrapper-logo" />
    </div>
  </section>
</template>

<script>
import FlashSaleLogoSVG from '@/assets/images/hero-section/premium-plus/pp-logo.svg'
import FlashSaleLogoMobileSVG from '@/assets/images/hero-section/premium-plus/pp-logo-mobile.svg'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'FlashSaleHeroSection',
  mixins: [routesRules],
  components: {
    FlashSaleLogoSVG: { ...FlashSaleLogoSVG, name: 'FlashSaleLogoSVG' },
    FlashSaleLogoMobileSVG: { ...FlashSaleLogoMobileSVG, name: 'FlashSaleLogoMobileSVG' },
  },
}
</script>

<style lang="scss" scoped>
.premium-plus-hero {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  @include font-book;
  display: grid;
  grid-template-columns: 1fr;

  flex-flow: column-reverse;

  align-items: center;
  position: relative;
  @include mobile {
    flex-flow: row;
    grid-template-columns: 64% 35%;
    padding: 0 20px;
    overflow: hidden;
  }
  @include tablet {
    flex-flow: row;
    grid-template-columns: 64% 35%;
    padding: 0;
    overflow: unset;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 160px 0;
    overflow: unset;
  }
  &__title {
    color: var(--white);
    @include font-medium;
    font-style: normal;
    font-size: rem(35px);
    font-weight: 900;
    line-height: rem(37px);
    margin: 0;
    max-width: 535px;
    @include mobile {
      font-size: rem(54px);
      line-height: rem(50px);
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    p {
      margin: 0;
      @include mobile {
        margin: 0 0 10px 0;
      }
    }
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    width: 100%;
    max-width: 615px;
    &-highlight {
      color: var(--white);
      font-weight: 700;
    }
    &-coupon-text {
      color: var(--white);
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      margin: 20px 0;
    }
    &-coupon {
      color: var(--strong-light-green);
      font-weight: 700;
    }

    @include mobile {
      width: 100%;
    }
    @include desktop {
      font-size: rem(24px);
      line-height: 32px;
    }
  }
  &__content {
    z-index: 1;
    display: flex;
    flex-flow: column;
    gap: 30px;
    margin-top: 30vh;
    max-width: unset;

    padding: 20px;

    @include mobile {
      width: 90%;
      margin-top: 0;
      max-width: 650px;
      padding: 0;
    }

    @include desktop {
      width: 100%;
      margin-top: 0;
    }
  }
  &__logo-wrapper {
    position: absolute;
    overflow: hidden;
    width: 100vw;
    top: -15vh;
    left: 0;

    display: none;

    @include tablet {
      top: -195px;
      left: auto;
      right: -265px;
      display: block;
    }

    @include mobile {
      width: auto;
      top: unset;
      left: unset;
      right: -17vw;
      overflow: auto;
      display: block;
    }

    &-mobile {
      position: absolute;
      overflow: hidden;
      width: 100vw;
      top: -65px;
      left: 0;
      @include mobile {
        display: none;
      }
    }

    &-logo {
      width: 600px;
      @include tablet {
        width: 990px;
      }
    }
  }
}
</style>
